  <mat-form-field appearance="fill" (click)="inputFocus()">
    <mat-label>{{ placeholderSelect | translate | uppercase}}</mat-label>
    <mat-select 
      [formControl]="selectCtrl" 
      [multiple]="isMultiple"
      [compareWith]="compareSelected"
      >
      <mat-select-trigger>
        <div class="mat-container">
          <span *ngIf="selectCtrl.value != null" matTooltip="{{selectCtrl.value.longDescription}}" class="mat-label">
            {{selectCtrl.value.longDescription}}
          </span>
          <span *ngIf="(selectCtrl.value.length || 0) == 1" matTooltip="{{selectCtrl.value[0].longDescription}}" class="mat-label">
            {{selectCtrl.value[0].longDescription}}
          </span>
          <span *ngIf="(selectCtrl.value?.length || 0) > 1" class="mat-label">
            {{(selectCtrl.value?.length || 0)}} selected elements
          </span>
          <span (click)="deselect($event)" class="mat-icon">
            <mat-icon>clear</mat-icon>
          </span>
        </div>          
      </mat-select-trigger>
      <div class="mat-option">
        <input #searchinput
        class="mat-select-search-input search-input-custom"
        style="border: 0 !important;"
        autocomplete="off"
        [type]="'text'"
        [formControl]="filterCtrl"
        [placeholder]="placeholderFilter"/>
      </div>
      <mat-option *ngFor="let item of dataSource | filterSelect:filterCtrl.value" [value]="item" (click)="onClick(item)" matTooltip="{{item.description}}"
       class="mat-option-custom" style="white-space: nowrap !important;">
          {{item.longDescription}}
      </mat-option>
    </mat-select>
  </mat-form-field> 